import { type EnumContainerActionRequest } from '@Model';
import { type Dispatch, type SetStateAction, useCallback } from 'react';
import { type ContainerPlanning } from './useContainerPlanning';

/**
 * Plans an action in an open card, so the planned row's first field can take the focus; a refused plan
 * leaves the card as it was.
 */
// @ai-generated 2026-10-26T09:50:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function usePlanAndOpen(
    planning: ContainerPlanning,
    beforePlan: () => void,
    opened: boolean,
    setOpened: Dispatch<SetStateAction<boolean>>,
) {
    return useCallback(
        async (action: EnumContainerActionRequest) => {
            beforePlan();
            setOpened(true);
            if (!(await planning.plan(action))) {
                setOpened(opened);
            }
        },
        [planning, beforePlan, opened, setOpened],
    );
}
